export type JwtTokenPayload = {
  iat: number;
  auth_time: number;
  jti: string;
  iss: string;
  aud: string;
  sub: string;
  typ: string;
  azp: string;
  nonce: string;
  session_state: string;
  acr: string;
  scope: string;
  spec_ver: string;
  legalname: string;
  countryCode: string;
  amr: string;
  typeOfActor: string;
  typeOfIdentifier: string;
  typeOfPerson: string;
  realm_access: {
    roles: string[];
  };
  eIdentifier: string; //cpr number
  skatMedarbejderADNummer: string; // caseworker id, format like: W1234567
};

export const getPayloadFromAccessToken = (token: string | undefined) => {
  if (!token) {
    return null;
  }
  return jwtPayloadMapper(token);
};

// the payload of the JTW token is encoded in the "base64 URL" format, not in the regular "base64" format,
// the "base64 URL" encoded string passed to the atob() function might generate an error:
// Failed to executed 'atob' on 'Window'. The string to be decoded is not correctly encoded.
const jwtPayloadMapper = (jwtToken: string) => {
  try {
    const payloadInBase64Url = jwtToken.split(".")[1];
    const payloadAsString = base64UrlToStringDecode(payloadInBase64Url);
    return JSON.parse(payloadAsString) as JwtTokenPayload;
  } catch (error) {
    console.error("The data processing problem occurred. Please, contact the administrator.", error);
    return null;
  }
};

function base64UrlToStringDecode(stringInBase64Url: string) {
  let result = stringInBase64Url.replace(/-/g, "+").replace(/_/g, "/");
  while (result.length % 4) {
    result += "=";
  }
  return atob(result);
}
